__turbopack_context__.v({
  "content": "tooltip-module__nrjMsa__content",
  "tooltipIn": "tooltip-module__nrjMsa__tooltipIn",
});
